class amendController {
    constructor($translate, $state, $stateParams, $location, $anchorScroll, $filter, myBookingService, cacheService, sharedService, CONFIG) {
        'ngInject';
        this.$translate = $translate;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.$anchorScroll = $anchorScroll;
        this.$filter = $filter;
        this.myBookingService = myBookingService;
        this.cacheService = cacheService;
        this.sharedService = sharedService;
        this.languages = CONFIG.languages;
        this.name = 'amend';
        this.showGoldProtection = false;
        this.TRANSFER_STATUS_ACTIVE = 'active';
    }

    $onInit() {
        this.translations = this.$translate.instant([
            "modify_booking_details",
            "modify_booking_details_2",
            "modify_booking_details_3",
            "content_title_amend",
            "msg_2",
            "type_taxi",
            "type_minivan",
            "type_minibus",
            "type_coach",
            "type_minicoach",
            "type_shuttle",
            "type_vip_car",
            "type_premium_minivan",
            "type_premium_taxi",
            "type_premium_minibus",
            "type_premium_minicoach",
            "type_city_taxi",
            "model_premium_taxi",
            "model_premium_minivan",
            "model_premium_minibus",
            "model_premium_minicoach",
            "model_vip_car",
            "more_info",
            "gad_email",
            "amend_send_confirmation_title",
            "subtitle_lead_passenger",
            "option_name",
            "option_family_name",
            "bar_transfers",
            "tab_title_amend",
            "dep_arr",
            "SMS_answer_1",
            "SMS_answer_2",
            "SMS_answer3",
            "label_vehicle",
            "label_title",
            "label_max",
            "msg_4",
            "title_1",
            "title_2",
            "title_3",
            "title_4",
            "vehicles_instructions",
            "vehicles_availability",
            "too_late_edit_transfer",
            "transfer_completed",
            "button_confirm_changes",
            "is_cancelled",
            "gp_add",
            "gp_new_title",
            "gp_new_title_1",
            "gp_new_exp",
            "gp_new_point1",
            "gp_new_point2",
            "gp_price",
            "err_fillall"
        ]);
        //TODO Clean up when we have correct segment
        angular.merge(this.translations, this.$filter('splitTranslationWithLink')('msg_4', {
            link_start: '%LINK_START%',
            link_end: '%LINK_END%'
        }));

        angular.merge(this.translations, this.$filter('splitTranslationWithLink')('terms_and_conditions_note', {
            link_start: '<a>',
            link_end: '</a>'
        }));

        this.translations.too_late_edit_transfer = this.$translate.instant("too_late_edit_transfer", {
            hours: this.amend.transfers[0].free_sale_deadline_check.free_sale_deadline_in_hours
        });

        //TODO Use languageService
        let language = this.languages[this.$translate.use()];
        this.terms_and_conditions_note_href = `http://www.suntransfers.com${ language.key == 'en' ? '/' : '/' + language.key + '/' }terms-and-conditions`;

        if (this.amend !== null) {
            let vehicle = this.amend.transfers[0].vehicle;
            let vehicleInfo = {
                'private': this.getPrivateMoreInfo,
                'shared': this.getSharedMoreInfo
            };

            vehicleInfo[vehicle.service_type].call(this, vehicle);

            this.lead_passenger_title = {
                "Mr": this.translations.title_1,
                "Mrs": this.translations.title_2,
                "Miss": this.translations.title_3,
                "Ms": this.translations.title_4
            };

            this.lead_passenger_titleInverted = {};
            for (var idx in this.lead_passenger_title) {
                this.lead_passenger_titleInverted[this.lead_passenger_title[idx]] = idx;
            }

            this.amend.lead_passenger.title = ' ';// this.lead_passenger_titleInverted[this.amend.lead_passenger.title];

            let smsTranslationKeys = {
                "no": this.translations.SMS_answer_1,
                "only voucher": this.translations.SMS_answer_2,
                "voucher +24h": this.translations.SMS_answer3
            };

            this.booking.translations.mainTitleKey = this.translations.content_title_amend;
            this.translations.smsText = smsTranslationKeys[this.amend.send_sms_type];

            this.amend.transfers = this.addTransferFlags(this.amend.transfers);
            this.showGoldProtection = this.setShowGoldProtection(this.amend);
        }
    }

    setShowGoldProtection(booking) {
        let showGoldProtection = booking.transfers.some((element) => {
            return element.flags.isActive && element.flags.isEditable && element.from.type == 'airport' && booking.gold_protection;
        });
        return showGoldProtection;
    }

    addTransferFlags(transfers) {
        return transfers.map((transfer) => {
            transfer.flags = {
                isActive: transfer.status === this.TRANSFER_STATUS_ACTIVE,
                isEditable: transfer.free_sale_deadline_check.is_valid,
                isAfterFreeSaleDeadLine: !transfer.free_sale_deadline_check.is_valid
            };
            return transfer;
        });
    }

    getSharedMoreInfo(vehicle) {
        let isStandardShuttle = vehicle.type == 'sh';

        this.translations.more_info_desc = this.$translate.instant('desc_shared', {
            num_luggage: vehicle.max_luggage,
            //TODO Retrun num_hand_luggage from BE
            num_hand_luggage: vehicle.max_luggage
        });

        if (this.translations['model_' + vehicle.type]) {
            this.translations.more_info_desc += '<p>' + this.translations['model_' + vehicle.type] + '</p>';
        }

        this.translations.more_info_desc += '<p>';
        this.translations.more_info_desc += this.$translate.instant('description_shared_1', {
            num_stops: isStandardShuttle ? 10 : 4
        });

        this.translations.more_info_desc += ' ' + this.$translate.instant('description_shared_2', {
            max_time: isStandardShuttle ? 45 : 30
        });
        this.translations.more_info_desc += '</p>';

        this.translations.more_info_desc += '<p>' + this.translations.vehicles_instructions + '</p>';
    }

    getPrivateMoreInfo(vehicle) {
        this.translations.more_info_desc = this.$translate.instant('desc_private', {
            vehicle_title: this.translations['type_' + vehicle.type],
            n1: vehicle.max_passengers,
            n2: vehicle.max_luggage
        });

        if (this.translations['model_' + vehicle.type]) {
            this.translations.more_info_desc += '<p>' + this.translations['model_' + vehicle.type] + '</p>';
        }

        this.translations.more_info_desc += '<p>' + this.translations.vehicles_instructions + '</p>';
        this.translations.more_info_desc += '<p>' + this.translations.vehicles_availability + '</p>';
    }

    range(num) {
        let arr = new Array(num);
        for (let i = 0; i < arr.length; i++) {
            arr[i] = i + 1;
        }
        return arr;
    }

    save(isUntouchedForm) {
        this.cacheService.set('statusAmendUpdated', !isUntouchedForm);
        this.myBookingService.saveAmend(this.$stateParams.bookingReference, this.dataToSaveTransformer(this.amend))
            .then((response) => {
                if (!this.amend.gold_protection && this.amend.gold_protection_check) {
                    let reference = this.cacheService.get('bookingReference');
                    this.$state.go('bookings.booking.goldupgrade', {
                        bookingReference: reference
                    });
                } else {
                    this.$state.reload();
                }

            })
            .catch((error) => {
            });
    }

    dataToSaveTransformer(amend) {
        let myAmend = angular.copy(amend);
        let dateFormat = "yyyy-MM-dd HH:mm:ss";
        let dateFormatter = (field, format) => {
            return field ? this.$filter('date')(field, format) : null;
        };

        //Reformat Phone prefix -> stPrefixes.controller removePrefix()
        let mobile_phone_prefix = myAmend.lead_passenger.mobile_phone_prefix ? myAmend.lead_passenger.mobile_phone_prefix + " " : '';
        myAmend.lead_passenger.mobile_phone = mobile_phone_prefix + myAmend.lead_passenger.mobile_phone;
        delete myAmend.lead_passenger.mobile_phone_prefix;

        //Return translated Lead passenger title
        myAmend.lead_passenger.title = ' '; // this.lead_passenger_title[myAmend.lead_passenger.title];

        myAmend.transfers = myAmend.transfers.map((transfer) => {
            delete transfer.flags;

            transfer.latest_pickup_time = dateFormatter(transfer.latest_pickup_time, dateFormat);
            transfer.pickup_time = dateFormatter(transfer.pickup_time, dateFormat);

            angular.forEach(['to', 'from'], function (legId) {
                var leg = transfer[legId];
                angular.forEach(['flight_datetime', 'train_datetime', 'cruise_datetime'], function(key) {
                    leg.data[key] = dateFormatter(leg.data[key], dateFormat);
                });
            });

            angular.forEach(['airline', 'origin_airport'], function(key) {
                transfer['from'].data[key] = (transfer['from'].data[key] === '' ? 'NOT_PROVIDED' : transfer['from'].data[key]);
            });

            return transfer;
        });

        return myAmend;
    }

    gotoCrcMessage() {
        this.$location.hash('crc_alert');
        this.$anchorScroll();
    };

    openChat() {
        const chat = document.querySelector('.inbenta-launcher');
        if (chat) {
            chat.click();
        } else if (!document.querySelector('.inbenta-avatar')) {
            zE.activate();
        }
        return false;
    }
}

export default amendController;



// WEBPACK FOOTER //
// ./client/app/routes/bookings/booking/amend/amend.controller.js